import { render, staticRenderFns } from "./SchriftWaehler.vue?vue&type=template&id=2075dcaf&scoped=true"
import script from "./SchriftWaehler.vue?vue&type=script&lang=js"
export * from "./SchriftWaehler.vue?vue&type=script&lang=js"
import style0 from "./SchriftWaehler.vue?vue&type=style&index=0&id=2075dcaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2075dcaf",
  null
  
)

export default component.exports